// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__r29es","left":"StickyBox_left__3tX0M","right":"StickyBox_right__1Q4-t"};